// Auth0 configuration for OSO Command.
//
// Uses the same Auth0 tenant + API audience as field-support-app, but a
// dedicated SPA application (its own client ID). Values come from
// REACT_APP_AUTH0_* env vars — see .env.example. The audience must match the
// backend's REACT_APP_AUTH0_AUDIENCE so the issued access token is accepted.
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || "",
  redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
};
